import { Stars } from '@react-three/drei'
import { ContourTerrain } from './ContourTerrain.jsx'
import { CameraRig } from './CameraRig.jsx'
import { Atmosphere } from './Atmosphere.jsx'
import { ExpeditionWorld } from './ExpeditionWorld.jsx'
import { Landmarks } from './Landmarks.jsx'

export function Scene({ reducedMotion, lowPower }) {
  return <>
    <color attach="background" args={['#82949e']} />
    <fog attach="fog" args={['#82949e', 52, 155]} />
    <ambientLight intensity={.5} color="#b4c6cc" />
    <directionalLight position={[-24,34,16]} intensity={4.4} color="#f4d99b" castShadow={!lowPower} shadow-mapSize={[1024,1024]} />
    <hemisphereLight args={['#c3d1d3','#26332e',.9]} />
    <ContourTerrain lowPower={lowPower} />
    <ExpeditionWorld lowPower={lowPower} />
    <Landmarks />
    <Atmosphere reducedMotion={reducedMotion} lowPower={lowPower} />
    {!lowPower && <Stars radius={130} depth={45} count={1100} factor={2.4} fade speed={reducedMotion?0:.06} />}
    <CameraRig reducedMotion={reducedMotion} />
  </>
}
